import getDestinationRoute from '@/utils/getDestinationRoute';

const getPropertyLink = (
  {
    propertyContent,
    searchQuery,
    packageOffer,
    noCampaignPackageOptions,
    packageOption,
  },
  destinationName,
) => {
  const propertyContentDestination = propertyContent.destination
    ? propertyContent.destination.name
    : null;
  const destinationRoute = getDestinationRoute(
    destinationName || propertyContentDestination,
  );
  const pathname = `/${destinationRoute}/properties/${propertyContent.id}/package`;
  return {
    pathname,
    query: {
      ...searchQuery,
      ...(packageOffer && {
        leadInRoomTypeId: packageOffer.roomTypeId,
      }),
      ...(propertyContent.theme && {
        themeName: propertyContent.theme.name,
      }),
      ...(noCampaignPackageOptions && { noCampaign: 'true' }),
      ...(packageOption && { packageOption }),
    },
  };
};

export default getPropertyLink;
